// MetaContentConfig.js
const MetaContentConfig = {
    default: {
      title: "Plastic - Your One-Stop Shop for Quality Plastic Products",
      description: "Discover a wide range of durable and eco-friendly plastic products at Plastic. Shop now for the best deals!",
      keywords: "plastic, eco-friendly, shop online",
      image: "https://localhost:3000/default.jpg",
      url: "https://localhost:3000",
    },
    about: {
      title: "About Us - Plastic",
      description: "Get to know the story behind Plastic.",
      keywords: "about us, our story, plastic",
    },
    contact: {
      title: "Contact Us - Plastic",
      description: "Reach out to the Plastic team for help or feedback.",
      keywords: "contact, support, customer service",
    },
    home: {
      title: "Home - Plastic",
      description: "Welcome to Plastic, your go-to destination for quality plastic products.",
      keywords: "home, trending, plastic",
    },
  };
  
  export default MetaContentConfig;
  